/**
 * AppConfigRepository
 *
 * Abstrai o acesso às configurações do terminal (chave/valor)
 * armazenadas localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const AppConfigRepository = {
  _api() {
    return getElectronAPI();
  },

  async get(key) {
    return this._api().config.get(key);
  },

  async set(key, value) {
    return this._api().config.set(key, value);
  },

  async getAll() {
    return this._api().config.getAll();
  },

  async getDeviceId() {
    const api = this._api();
    const saved = await api.config.get("device_id");
    if (saved) return saved;

    if (api.device && typeof api.device.getDeviceId === "function") {
      return api.device.getDeviceId();
    }

    return null;
  },

  /** Atalho: retorna as configurações mais usadas pelo PDV */
  async getTerminalConfig() {
    const api = this._api();
    const [
      id_terminal_venda,
      uuid_terminal,
      id_empresa,
      id_configuracao,
      serie_nfe,
      proxima_venda,
      api_token,
      device_id,
    ] = await Promise.all([
      api.config.get("id_terminal_venda"),
      api.config.get("uuid_terminal"),
      api.config.get("id_empresa"),
      api.config.get("id_configuracao"),
      api.config.get("serie_nfe"),
      api.config.get("proxima_venda"),
      api.config.get("api_token"),
      this.getDeviceId(),
    ]);

    return {
      id_terminal_venda: id_terminal_venda ? parseInt(id_terminal_venda, 10) : null,
      uuid_terminal:     uuid_terminal     ?? null,
      id_empresa:        id_empresa        ? parseInt(id_empresa, 10)        : null,
      id_configuracao:   id_configuracao   ?? null,
      serie_nfe:         serie_nfe         ?? "1",
      proxima_venda:     parseInt(proxima_venda || "1", 10),
      api_token:         api_token         ?? null,
      device_id:         device_id         ?? null,
    };
  },

  async incrementarProximaVenda() {
    return this._api().terminal.incrementarProximaVenda();
  },
};

export default AppConfigRepository;
